import "./QOSByQuotient.module.css";
import Header from "@/reusable_sections/Header";
import IntroductionToJupiterMedia from "./sections/IntroductionToJupiterMedia";
import CoreArchitecture from "./sections/CoreArchitecture";
import NativeWorkflows from "./sections/NativeWorkflows";
import DeploymentEnvironments from "./sections/DeploymentEnvironments";
import OurDigitalFortress from "./sections/OurDigitalFortress";
import TheLoungeInterface from "./sections/TheLoungeInterface";
import OperatorUseCases from "./sections/OperatorUseCases";
import InitiateMembership from "./sections/InitiateMembership";
import Footer from "@/reusable_sections/Footer";
export default function QOSByQuotientPage() {
  return <div>
      <Header />
      <IntroductionToJupiterMedia />
      <CoreArchitecture />
      <NativeWorkflows />
      <DeploymentEnvironments />
      <OurDigitalFortress />
      <TheLoungeInterface />
      <OperatorUseCases />
      <InitiateMembership />
      <Footer />
    </div>;
}